import env from '@/env';
import axiosInst from './axiosInst';
import PortOne from "@portone/browser-sdk/v2";
import emitter from './eventBus';

export default {
  install(app) {
    app.config.globalProperties.$openModal = (type, options = {}) => {
      emitter.emit('openModal', { type, options });
    };
    // html 태그 text만 리턴
    app.config.globalProperties.$stripHtmlTags = function (html) {
      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = html;
      return tempDiv.textContent || tempDiv.innerText || "";
    },
    // input태그 금액 입력 시 숫자 외 제거, 쉼표 추가
    app.config.globalProperties.$filterAmountInput = function (amount) {
      return amount.replace(/[^0-9]/g, '')
                   .replace(/^0+/, '')
                   .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },
    // 이미지url
    app.config.globalProperties.$getImgUrl = function (imgSrc) {
      if (imgSrc == '' || imgSrc.startsWith("data:image")) {
        return imgSrc;
      }
      return `${env.api.SPRING_API_URL}/file/image?path=${encodeURIComponent(imgSrc)}`;
    },
    // 파일 다운로드(경로, 원본 파일명(originalName))
    app.config.globalProperties.$downloadFile = function (path, fileName) {
      return `${env.api.SPRING_API_URL}/file/download?path=${encodeURIComponent(path)}&fileName=${fileName}`;
    },
    // 금액 쉼표 추가
    app.config.globalProperties.$addComma = function (amount) {
      if (amount == null) return '0';
      return amount.toLocaleString('en-US');
    },
    // 최대 글자 수 제어
    app.config.globalProperties.$truncateText = function (text, maxLength) {
      if (!text || text.length <= maxLength) return text;
      return text.substring(0, maxLength) + '...';
    };
    // 날짜 한글화
    app.config.globalProperties.$localizeDate = function (dateString, includeYear) {
      if (includeYear) return dateString.substring(0, 4) + '년 ' + dateString.substring(5, 7) + '월 ' + dateString.substring(8, 10) + '일'
      else return dateString.substring(5, 7) + '월 ' + dateString.substring(8, 10) + '일'
    }
    // 날짜 요일 찾기
    app.config.globalProperties.$getDayName = function (dateString, isFull) {
      var days = []
      if (isFull) {
        days = ['일요일', '월요일', '화요일', '수요일', '목요일', '금요일', '토요일']
      } else {
        days = ['일', '월', '화', '수', '목', '금', '토']
      }
      const date = new Date(dateString)
      return days[date.getDay()]
    }

    app.config.globalProperties.$makePayment = async function (payload) {
      const {paymentAmount, name, invitationSeq} = payload
      const paymentId = crypto.randomUUID();
      const payment = await PortOne.requestPayment({
        storeId: env.api.STORE_ID,
        channelKey: env.api.CHANNEL_KEY,
        paymentId,
        orderName: name,
        totalAmount: paymentAmount,
        currency: "KRW",
        payMethod: "CARD",
        customData: {
          item: "1"
        }
      })

      if (payment.code !== undefined) {
        alert("결제 실패")
        return
      }

      const id = payment.paymentId
      const result = await axiosInst.springAxiosInst.post(`/payment/verify/${id}/${invitationSeq}`)
            .then((res) => {
              return res.data
            })
            .catch((err) => {
              console.error("결제 검증 중 오류 발생:", err)
            })
      if (result.status === "PAID") {
        alert("결제 검증 완료! 주문 처리 진행")
        // 주문 완료 처리 로직 추가
      } else {
        alert("결제 검증 실패! 고객센터 문의 필요")
      }
    }

    // 일반 화환 주문 사이트로 이동
    app.config.globalProperties.$openGeneralFlowerSite = function (locationName) {
      // ✅ 삼성 장례식장일 때만 이동
      if (locationName && locationName.includes('삼성서울병원 장례식장')) {
        const ok = window.confirm(
          '일반 화환 주문 사이트로 이동하시겠습니까?\n일반 화환은 별도 사이트에서 개별 주문해야 합니다.'
        );
        if (ok) {
          window.open(
            'http://www.samsunghospital.com/home/funerals/service.do?view=flower',
            '_blank'
          );
        }
      } else {
        // ❗ 그 외는 준비중
        alert('일반 화환 서비스는 현재 준비중입니다.\n곧 오픈 예정입니다.');
      }
    }
    
  },
}